// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cremaNavbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 14px 10px 16px;
  min-height: 84px;
  border: 1px solid #dde3eb;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
  margin-bottom: 16px;
}

.cremaNavbar--sticky {
  position: sticky;
  top: 0;
  z-index: 900;
  isolation: isolate;
  margin-bottom: 0;
}

.cremaNavbar__left {
  min-width: 0;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: 18px;
}

.cremaNavbar__logoLink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #eaedf3;
  padding-right: 18px;
  text-decoration: none;
  flex-shrink: 0;
}

.cremaNavbar__logo {
  width: 160px;
  max-width: 100%;
  height: auto;
  display: block;
}

.cremaNavbar__content {
  min-width: 0;
  flex: 1 1 auto;
}

.cremaNavbar__searchPanel {
  width: 100%;
  max-width: 720px;
}

.cremaNavbar__right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.cremaNavbar__languageTrigger {
  min-width: 56px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 14px !important;
  border: 1px solid #e2e7ef !important;
  border-radius: 999px !important;
  background: #f4f6fb !important;
  color: #1f2a44 !important;
  font: 600 14px/1 "Roboto", sans-serif !important;
  -webkit-user-select: none;
          user-select: none;
}

.cremaNavbar__languageTrigger:hover {
  background: #eaf0fb !important;
  border-color: #ccd6e5 !important;
}

.cremaNavbar__userTrigger {
  border: 1px solid #e2e7ef;
  border-radius: 999px;
  background: #f4f6fb;
  padding: 0;
  height: 46px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.cremaNavbar__userTrigger:hover {
  background: #eaf0fb;
  border-color: #ccd6e5;
}

.cremaNavbar__userTrigger .mainSidebar__userBlock {
  padding: 4px 12px 4px 4px;
  gap: 8px;
}

.cremaNavbar__userTrigger .mainSidebar__userAvatar {
  width: 34px;
  height: 34px;
  min-width: 34px;
}

.cremaNavbar__userTrigger .mainSidebar__userName {
  font-size: 13px;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
}

.cremaNavbar__userTrigger .mainSidebar__userRole {
  font-size: 11px;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
}

.cremaNavbar__userTrigger .mainSidebar__userChevron {
  color: #1f2a44;
  font-size: 12px;
}

.cremaNavbar__userTrigger[aria-expanded=true] .mainSidebar__userChevron {
  transform: rotate(180deg);
}

.cremaNavbar__userMenu {
  margin-top: 8px;
  border: 1px solid #dfe4ec !important;
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.14) !important;
  min-width: 220px;
  padding: 6px !important;
}

.cremaNavbar__userMenu .ant-btn {
  width: 100%;
  justify-content: flex-start;
  border-radius: 8px !important;
  font-size: 14px;
}

.cremaNavbar__iconAction .ant-btn,
.cremaNavbar__cartButton.ant-btn {
  width: 46px;
  min-width: 46px;
  height: 46px;
  border: 1px solid #e2e7ef;
  border-radius: 999px;
  background: #f4f6fb;
  color: #1f2a44;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cremaNavbar__iconAction .ant-btn:hover,
.cremaNavbar__iconAction .ant-btn:focus,
.cremaNavbar__cartButton.ant-btn:hover,
.cremaNavbar__cartButton.ant-btn:focus {
  background: #eaf0fb !important;
  border-color: #ccd6e5 !important;
  color: #15213b !important;
}

.cremaNavbar__iconAction .anticon,
.cremaNavbar__cartButton .anticon {
  font-size: 20px;
}

.cremaNavbar__company {
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #2d3348;
  font: 500 16px/1.3 "Roboto", sans-serif;
}

.cremaNavbar .search-panel {
  border: 1px solid #dfe4ec;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.cremaNavbar .search-panel .favIcon.ant-btn {
  border: none !important;
  border-right: 1px solid #dfe4ec !important;
  border-radius: 0 !important;
  width: 52px;
  min-width: 52px;
  height: 52px;
  color: #3d4557;
}

.cremaNavbar .search-panel .favIcon.ant-btn:hover,
.cremaNavbar .search-panel .favIcon.ant-btn:focus {
  background: #f5f7fb !important;
  color: #1f2a44 !important;
}

.cremaNavbar .search-panel .ant-input {
  border: none !important;
  box-shadow: none !important;
  height: 52px;
  padding: 0 14px;
  font-size: 16px;
}

.cremaNavbar .search-panel .ant-input::placeholder {
  color: #9aa3b2;
}

.cremaNavbar .search-panel__config {
  right: 4px;
}

.cremaNavbar__cart {
  padding: 2px 12px 2px 2px !important;
  min-height: 50px;
  background: #ffffff !important;
  border: 1px solid #dfe4ec !important;
  border-radius: 14px !important;
  gap: 10px !important;
}

.cremaNavbar__cartLink {
  display: inline-flex;
  text-decoration: none;
}

.cremaNavbar__cartAmount {
  margin-right: 0 !important;
  color: #1f2a44;
  font: 700 16px/1.2 "Roboto", sans-serif;
}

@media screen and (max-width: 1439.98px) {
  .cremaNavbar {
    padding: 10px 12px;
  }
  .cremaNavbar__logo {
    width: 138px;
  }
  .cremaNavbar__company {
    max-width: 190px;
  }
}
@media screen and (max-width: 1199.98px) {
  .cremaNavbar {
    flex-wrap: wrap;
    gap: 12px;
  }
  .cremaNavbar__left {
    width: 100%;
  }
  .cremaNavbar__right {
    width: 100%;
    justify-content: flex-end;
  }
}
@media screen and (max-width: 767.98px) {
  .cremaNavbar {
    padding: 8px;
    border-radius: 12px;
    gap: 10px;
  }
  .cremaNavbar__logoLink {
    display: none;
  }
  .cremaNavbar__company {
    display: none;
  }
  .cremaNavbar .search-panel .ant-input {
    font-size: 14px;
  }
  .cremaNavbar__iconAction .ant-btn,
  .cremaNavbar__cartButton.ant-btn,
  .cremaNavbar__languageTrigger {
    width: 40px;
    min-width: 40px;
    height: 40px;
    padding: 0 10px !important;
  }
  .cremaNavbar__userTrigger {
    height: 40px;
  }
  .cremaNavbar__userTrigger .mainSidebar__userBlock {
    padding: 4px 8px 4px 4px;
    gap: 6px;
  }
  .cremaNavbar__userTrigger .mainSidebar__userAvatar {
    width: 30px;
    height: 30px;
    min-width: 30px;
  }
  .cremaNavbar__userTrigger .mainSidebar__userInfo {
    display: none;
  }
  .cremaNavbar__cart {
    min-height: 44px;
    padding: 2px 8px 2px 2px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/navbar/Navbar.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,4BAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CAAA;EACA,mBAAA;AACF;;AACA;EACE,gBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAEF;;AAAA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAGF;;AADA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AAIF;;AAFA;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAKF;;AAHA;EACE,YAAA;EACA,cAAA;AAMF;;AAJA;EACE,WAAA;EACA,gBAAA;AAOF;;AALA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAQF;;AANA;EACE,eAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,0BAAA;EACA,oCAAA;EACA,+BAAA;EACA,8BAAA;EACA,yBAAA;EACA,gDAAA;EACA,yBAAA;UAAA,iBAAA;AASF;;AAPA;EACE,8BAAA;EACA,gCAAA;AAUF;;AARA;EACE,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,8DAAA;AAWF;;AATA;EACE,mBAAA;EACA,qBAAA;AAYF;;AAVA;EACE,yBAAA;EACA,QAAA;AAaF;;AAXA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAcF;;AAZA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAeF;;AAbA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAgBF;;AAdA;EACE,cAAA;EACA,eAAA;AAiBF;;AAfA;EACE,yBAAA;AAkBF;;AAhBA;EACE,eAAA;EACA,oCAAA;EACA,8BAAA;EACA,8BAAA;EACA,yDAAA;EACA,gBAAA;EACA,uBAAA;AAmBF;;AAjBA;EACE,WAAA;EACA,2BAAA;EACA,6BAAA;EACA,eAAA;AAoBF;;AAlBA;;EAEE,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAqBF;;AAnBA;;;;EAIE,8BAAA;EACA,gCAAA;EACA,yBAAA;AAsBF;;AApBA;;EAEE,eAAA;AAuBF;;AArBA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,uCAAA;AAwBF;;AAtBA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAyBF;;AAvBA;EACE,uBAAA;EACA,0CAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AA0BF;;AAxBA;;EAEE,8BAAA;EACA,yBAAA;AA2BF;;AAzBA;EACE,uBAAA;EACA,2BAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AA4BF;;AA1BA;EACE,cAAA;AA6BF;;AA3BA;EACE,UAAA;AA8BF;;AA5BA;EACE,oCAAA;EACA,gBAAA;EACA,8BAAA;EACA,oCAAA;EACA,8BAAA;EACA,oBAAA;AA+BF;;AA7BA;EACE,oBAAA;EACA,qBAAA;AAgCF;;AA9BA;EACE,0BAAA;EACA,cAAA;EACA,uCAAA;AAiCF;;AA/BA;EACE;IACE,kBAAA;EAkCF;EAhCA;IACE,YAAA;EAkCF;EAhCA;IACE,gBAAA;EAkCF;AACF;AAjCA;EACE;IACE,eAAA;IACA,SAAA;EAmCF;EAjCA;IACE,WAAA;EAmCF;EAjCA;IACE,WAAA;IACA,yBAAA;EAmCF;AACF;AAlCA;EACE;IACE,YAAA;IACA,mBAAA;IACA,SAAA;EAoCF;EAlCA;IACE,aAAA;EAoCF;EAlCA;IACE,aAAA;EAoCF;EAlCA;IACE,eAAA;EAoCF;EAlCA;;;IAGE,WAAA;IACA,eAAA;IACA,YAAA;IACA,0BAAA;EAoCF;EAlCA;IACE,YAAA;EAoCF;EAlCA;IACE,wBAAA;IACA,QAAA;EAoCF;EAlCA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAoCF;EAlCA;IACE,aAAA;EAoCF;EAlCA;IACE,gBAAA;IACA,mCAAA;EAoCF;AACF","sourcesContent":[".cremaNavbar\n  display: flex\n  align-items: center\n  justify-content: space-between\n  gap: 16px\n  padding: 10px 14px 10px 16px\n  min-height: 84px\n  border: 1px solid #dde3eb\n  border-radius: 16px\n  background: #ffffff\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06)\n  margin-bottom: 16px\n\n.cremaNavbar--sticky\n  position: sticky\n  top: 0\n  z-index: 900\n  isolation: isolate\n  margin-bottom: 0\n\n.cremaNavbar__left\n  min-width: 0\n  flex: 1 1 auto\n  display: flex\n  align-items: center\n  gap: 18px\n\n.cremaNavbar__logoLink\n  display: inline-flex\n  align-items: center\n  justify-content: center\n  border-right: 1px solid #eaedf3\n  padding-right: 18px\n  text-decoration: none\n  flex-shrink: 0\n\n.cremaNavbar__logo\n  width: 160px\n  max-width: 100%\n  height: auto\n  display: block\n\n.cremaNavbar__content\n  min-width: 0\n  flex: 1 1 auto\n\n.cremaNavbar__searchPanel\n  width: 100%\n  max-width: 720px\n\n.cremaNavbar__right\n  display: flex\n  align-items: center\n  gap: 10px\n  flex-shrink: 0\n\n.cremaNavbar__languageTrigger\n  min-width: 56px\n  height: 46px\n  display: inline-flex\n  align-items: center\n  justify-content: center\n  gap: 6px\n  padding: 0 14px !important\n  border: 1px solid #e2e7ef !important\n  border-radius: 999px !important\n  background: #f4f6fb !important\n  color: #1f2a44 !important\n  font: 600 14px/1 \"Roboto\", sans-serif !important\n  user-select: none\n\n.cremaNavbar__languageTrigger:hover\n  background: #eaf0fb !important\n  border-color: #ccd6e5 !important\n\n.cremaNavbar__userTrigger\n  border: 1px solid #e2e7ef\n  border-radius: 999px\n  background: #f4f6fb\n  padding: 0\n  height: 46px\n  display: inline-flex\n  align-items: center\n  cursor: pointer\n  transition: background-color 0.2s ease, border-color 0.2s ease\n\n.cremaNavbar__userTrigger:hover\n  background: #eaf0fb\n  border-color: #ccd6e5\n\n.cremaNavbar__userTrigger .mainSidebar__userBlock\n  padding: 4px 12px 4px 4px\n  gap: 8px\n\n.cremaNavbar__userTrigger .mainSidebar__userAvatar\n  width: 34px\n  height: 34px\n  min-width: 34px\n\n.cremaNavbar__userTrigger .mainSidebar__userName\n  font-size: 13px\n  line-height: 1.1\n  white-space: nowrap\n  overflow: hidden\n  text-overflow: ellipsis\n  max-width: 130px\n\n.cremaNavbar__userTrigger .mainSidebar__userRole\n  font-size: 11px\n  line-height: 1.1\n  white-space: nowrap\n  overflow: hidden\n  text-overflow: ellipsis\n  max-width: 130px\n\n.cremaNavbar__userTrigger .mainSidebar__userChevron\n  color: #1f2a44\n  font-size: 12px\n\n.cremaNavbar__userTrigger[aria-expanded=\"true\"] .mainSidebar__userChevron\n  transform: rotate(180deg)\n\n.cremaNavbar__userMenu\n  margin-top: 8px\n  border: 1px solid #dfe4ec !important\n  border-radius: 12px !important\n  background: #ffffff !important\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.14) !important\n  min-width: 220px\n  padding: 6px !important\n\n.cremaNavbar__userMenu .ant-btn\n  width: 100%\n  justify-content: flex-start\n  border-radius: 8px !important\n  font-size: 14px\n\n.cremaNavbar__iconAction .ant-btn,\n.cremaNavbar__cartButton.ant-btn\n  width: 46px\n  min-width: 46px\n  height: 46px\n  border: 1px solid #e2e7ef\n  border-radius: 999px\n  background: #f4f6fb\n  color: #1f2a44\n  box-shadow: none\n  display: inline-flex\n  align-items: center\n  justify-content: center\n\n.cremaNavbar__iconAction .ant-btn:hover,\n.cremaNavbar__iconAction .ant-btn:focus,\n.cremaNavbar__cartButton.ant-btn:hover,\n.cremaNavbar__cartButton.ant-btn:focus\n  background: #eaf0fb !important\n  border-color: #ccd6e5 !important\n  color: #15213b !important\n\n.cremaNavbar__iconAction .anticon,\n.cremaNavbar__cartButton .anticon\n  font-size: 20px\n\n.cremaNavbar__company\n  max-width: 260px\n  white-space: nowrap\n  overflow: hidden\n  text-overflow: ellipsis\n  color: #2d3348\n  font: 500 16px/1.3 \"Roboto\", sans-serif\n\n.cremaNavbar .search-panel\n  border: 1px solid #dfe4ec\n  border-radius: 12px\n  overflow: hidden\n  background: #fff\n\n.cremaNavbar .search-panel .favIcon.ant-btn\n  border: none !important\n  border-right: 1px solid #dfe4ec !important\n  border-radius: 0 !important\n  width: 52px\n  min-width: 52px\n  height: 52px\n  color: #3d4557\n\n.cremaNavbar .search-panel .favIcon.ant-btn:hover,\n.cremaNavbar .search-panel .favIcon.ant-btn:focus\n  background: #f5f7fb !important\n  color: #1f2a44 !important\n\n.cremaNavbar .search-panel .ant-input\n  border: none !important\n  box-shadow: none !important\n  height: 52px\n  padding: 0 14px\n  font-size: 16px\n\n.cremaNavbar .search-panel .ant-input::placeholder\n  color: #9aa3b2\n\n.cremaNavbar .search-panel__config\n  right: 4px\n\n.cremaNavbar__cart\n  padding: 2px 12px 2px 2px !important\n  min-height: 50px\n  background: #ffffff !important\n  border: 1px solid #dfe4ec !important\n  border-radius: 14px !important\n  gap: 10px !important\n\n.cremaNavbar__cartLink\n  display: inline-flex\n  text-decoration: none\n\n.cremaNavbar__cartAmount\n  margin-right: 0 !important\n  color: #1f2a44\n  font: 700 16px/1.2 \"Roboto\", sans-serif\n\n@media screen and (max-width: 1439.98px)\n  .cremaNavbar\n    padding: 10px 12px\n\n  .cremaNavbar__logo\n    width: 138px\n\n  .cremaNavbar__company\n    max-width: 190px\n\n@media screen and (max-width: 1199.98px)\n  .cremaNavbar\n    flex-wrap: wrap\n    gap: 12px\n\n  .cremaNavbar__left\n    width: 100%\n\n  .cremaNavbar__right\n    width: 100%\n    justify-content: flex-end\n\n@media screen and (max-width: 767.98px)\n  .cremaNavbar\n    padding: 8px\n    border-radius: 12px\n    gap: 10px\n\n  .cremaNavbar__logoLink\n    display: none\n\n  .cremaNavbar__company\n    display: none\n\n  .cremaNavbar .search-panel .ant-input\n    font-size: 14px\n\n  .cremaNavbar__iconAction .ant-btn,\n  .cremaNavbar__cartButton.ant-btn,\n  .cremaNavbar__languageTrigger\n    width: 40px\n    min-width: 40px\n    height: 40px\n    padding: 0 10px !important\n\n  .cremaNavbar__userTrigger\n    height: 40px\n\n  .cremaNavbar__userTrigger .mainSidebar__userBlock\n    padding: 4px 8px 4px 4px\n    gap: 6px\n\n  .cremaNavbar__userTrigger .mainSidebar__userAvatar\n    width: 30px\n    height: 30px\n    min-width: 30px\n\n  .cremaNavbar__userTrigger .mainSidebar__userInfo\n    display: none\n\n  .cremaNavbar__cart\n    min-height: 44px\n    padding: 2px 8px 2px 2px !important\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
